@if (selectedRatingFilter() > 0) {
  <div class="flex gap-x-2 pb-3">
    <span class="font-title text-[20px]">
      {{ "COMPONENT.AVIS-GOOGLE-DETAILS.REVIEWS_STAR" | translatePlural: "REVIEWS_STARS" : selectedRatingFilter() }}
    </span>
    <span class="flex cursor-pointer items-center gap-x-1" (click)="resetRatingFilter()">
      <span>{{ "ACTION.CLEAR_FILTER" | translate }}</span>
      <app-svg src="assets/icons/close.svg" [width]="7" />
    </span>
  </div>
} @else {
  <div class="text-pretty pb-3 font-title text-[20px]">
    {{ "COMPONENT.AVIS-GOOGLE-DETAILS.SORT_BY_HIGHEST_TO_LOWEST_RATED" | translate }}
  </div>
}
<ul class="flex flex-col gap-y-4">
  @for (review of reviews(); track review.id) {
    <li
      class="flex flex-col gap-y-0.5 rounded-[20px] bg-gray-light p-4"
      (viewportObserver)="onReviewViewportEnter($event, review.id)">
      <div class="text-[20px] font-bold">{{ review.author }}</div>
      <div class="flex items-end gap-x-1.5 pb-2">
        <app-star-rating-display [note]="review.rating" size="SMALL" />
        <span class="text-sm font-bold">{{ review.date | date: "dd/MM/yyyy" : undefined }}</span>
      </div>
      <div class="font-medium">{{ review.content }}</div>
    </li>
  }
</ul>
@if (loadMoreMode() === "button") {
  <div class="mt-5 flex justify-center">
    <app-button [label]="'COMPONENT.AVIS-GOOGLE-DETAILS.SEE_MORE_REVIEWS' | translate" (onButtonClick)="loadMore()" />
  </div>
}
